import { roundTo } from '../utils';
import { creamCost } from '../index';

export interface SellCommissions {
  total: number;
  creamTotal: number;
}

export const getSellComissions = (
  creamAmount: string | number
): SellCommissions => {
  const creamTotal = roundTo(Number(creamAmount) * 0.9, 0, 'lower');
  const total = roundTo(creamTotal * creamCost, 4);
  return { total, creamTotal };
};
